import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { getYmmeYears } from "@store/Services/YmmeService";

type HandlerType = Handler<{
    make: string;
    model: string;
    engine: string;
}>;

export const FetchYmmeYears: HandlerType = async ({ dispatch, parameter }) => {
    const untypedDispatch: any = dispatch;
    const modelsResults = await getYmmeYears(parameter.make, parameter.model, parameter.engine);
    untypedDispatch({
        type: "Custom/Ymme/YearsLoaded",
        parameter: modelsResults,
    });
};

export const chain = [FetchYmmeYears];

const fetchYmmeYears = createHandlerChainRunner(chain, "FetchYmmeYears");
export default fetchYmmeYears;
